<template>
    <div class="answer-list-content answer-list-generic-question-edit">

        <!-- ----------------------------------------- -->
        <!-- ANSWER LIST FOR EDIT ANSWER POPUP         -->
        <!-- ----------------------------------------- -->

        <div v-if="getCrtEditingQuestionData && getCrtEditingQuestionData.answers" class="answer-items">
            <div v-for="answer in getCrtEditingQuestionData.answers"
                 :key="answer.code"
                 :ref="'answer-item-'+answer.code"
                 class="answer-item"
                 :class="{'is-already-provided-answer': (answer.code === getCrtEditingQuestionData.providedAnswer)}">
                <span @click="handleClickAnswer(answer, getCrtEditingQuestionData)"
                      class="answer-item-text"
                      :id="'A_EDIT_' + answer.code"

                >{{answer.text}}</span>
            </div>
        </div>

    </div>
</template>

<!-- ################################################################## -->

<script>
import {mapGetters} from 'vuex';

export default {
        name: 'AnswerListEditingQuestion',

        data() {
            return {
                isClickDisabled: false
            };
        },
        computed: {
            ...mapGetters({
                getCrtEditingQuestionData: 'ChatBotStore/getCrtEditingQuestionData',
                getAssessmentStatuses: "ChatBotStore/getAssessmentStatuses",
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            })
        },
        updated: function () {
            this.isClickDisabled = false; // Answer list has been updated (we have a new set of answers), so we make sure that clicks are enabled.
        },

        methods: {

            handleClickAnswer (clickedAnswer, question) {

                if (this.isClickDisabled === true) {
                    return; // Clicks are disabled, so do nothing else.
                }
                else {
                    this.isClickDisabled = true; // Clicks were enabled until now. We disable them now (so no other clicks are possible), then execute the actions for current click.
                }

                let clickedAnswerElem = this.$refs['answer-item-'+clickedAnswer.code][0];
                clickedAnswerElem.classList.add('answer-item-clicked');

                // @TODO | Maybe we can remove the class by changing/clearing the "providedAnswer" value in "crtEditingQuestionData" object in store and let Vue to automatically handle the class removal. That would be a better solution.
                let providedAnswer = document.getElementsByClassName('is-already-provided-answer');
                if (providedAnswer.length > 0) {
                    providedAnswer[0].classList.remove('is-already-provided-answer');
                }

                let promiseAnswerSubmitted;

                if (question.type === this.getAssessmentStatuses.NO_OTHER_SYMPTOMS) {
                    // Submit edited answer for No Other Symptom question.
                    promiseAnswerSubmitted = this.$store.dispatch("ChatBotStore/submitEditedNoOtherSymptomsAnswer", {
                        "answerCode": clickedAnswer.code,
                        "edit": true
                    });
                }
                else {
                    // Submit edited answer for a generic question (all that is not Main Symptom, Related Symptom or No Other Symptom).
                    promiseAnswerSubmitted = this.$store.dispatch("ChatBotStore/submitEditedAnswer", {
                        "answerCode": clickedAnswer.code,
                        "questionCode": question.code,
                        "edit": true
                    });
                }

                promiseAnswerSubmitted.then((response) => {
                    // Answer saved
                    let that = this;

                    setTimeout(function() {
                        that.$emit("onAnswerSubmitted", response);
                        clickedAnswerElem.classList.remove('answer-item-clicked');
                    }, 200)

                });

            },

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    /*.answer-list-content {*/
    /*    width: 100%;*/
    /*    padding-left: 24px;*/
    /*    padding-right: 24px;*/
    /*}*/

    /*.answer-item {*/
    /*    padding-bottom: 8px;*/

    /*    .answer-item-text {*/
    /*        display: block;*/
    /*        border: 1px solid #d3d5d9;*/
    /*        border-radius: 30px;*/
    /*        padding: 8px !important;*/
    /*        color: #a43a45;*/
    /*        cursor: pointer;*/
    /*        white-space: pre-wrap;*/
    /*    }*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListEditingQuestion.vue